export default __webpack_public_path__ + "static/media/sort_up.d4aa6ef2.svg";